import Repository from './Repository'

const action = 'sms/send'

export default {
  pushSmsRequests(data) {
    return Repository.post(action, data)
  },
}
